// extracted by mini-css-extract-plugin
export default {"container":"SummaryItem_container__PNpW3","edit":"SummaryItem_edit__BRtbZ","itemHeader":"SummaryItem_itemHeader__CumBA","bold":"SummaryItem_bold__kMEcV"};